import React from "react";

const DropdownIcon = ({ bg, fill }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0" fill={bg} width="24" height="24" />

      <g fill={fill}>
        <path d="M7 10l5 5 5-5" />
      </g>
    </svg>
  );
};

export default DropdownIcon;
